{
  "dismiss": "Kapat"
}